import axios from "axios";
import { CUSTOMERS_ENDPOINT } from "./APIEndpoints";
axios.defaults.withCredentials = true;
export const getAllCustomers = async (token) => {
    try {
      const res = await axios.get(`${CUSTOMERS_ENDPOINT}`);
      return res.data;
    } catch (err) {
      console.error(err.response);
      throw err;
    }
  };
export const getPaymentRecords = async (mozzazCustomerID) => {
    try {
      const res = await axios.get(`${CUSTOMERS_ENDPOINT}/${mozzazCustomerID}/paymentrecords?limit=5`);
      return res.data;
    } catch (err) {
      console.error(err.response);
      throw err;
    }
};

export const getCustomerSubscriptions = async (mozzazCustomerID) => {
  try {
    const res = await axios.get(`${CUSTOMERS_ENDPOINT}/${mozzazCustomerID}/subscriptions`);
    return res.data;
  } catch (err) {
    console.error(err.response);
    throw err;
  }
};